import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

/**
 * Custom hook to replace Next.js useRouter
 * Provides similar API using React Router
 */
export function useRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const [searchParams] = useSearchParams()

  const router = useMemo(() => ({
    // Navigate to a new route
    push: (url: string) => {
      navigate(url)
    },

    // Replace current route
    replace: (url: string) => {
      navigate(url, { replace: true })
    },

    // Go back
    back: () => {
      navigate(-1)
    },

    // Current pathname
    pathname: location.pathname,

    // Query parameters as an object
    query: Object.fromEntries([...searchParams]),

    // Route parameters
    params,

    // Search string (e.g., "?foo=bar")
    search: location.search,

    // Hash (e.g., "#section")
    hash: location.hash,
  }), [navigate, location, params, searchParams])

  return router
}
